/**
 * The two actions every MTM referential screen shares: deleting an item and
 * closing its dialog, both refreshing the list.
 */
import { useMutation } from '@tanstack/react-query';
import { snackbar } from '@/shared/ui/snackbar';

export type DialogResult = 'Confirm' | 'Cancel';

export const useDeleteItem = <Item>(
  deleteItem: (item: Item) => Promise<unknown>,
  refresh: () => unknown,
) =>
  useMutation({
    mutationFn: deleteItem,
    onSuccess: () => {
      snackbar('Successfully deleted');
      void refresh();
    },
    onError: () => snackbar('Failed to delete item, please try again later'),
  });

/** Closes the dialog; a confirmed save is announced and reloads the list. */
export const useSavedDialogClose =
  (close: () => void, refresh: () => unknown) => (result: DialogResult) => {
    close();
    if (result === 'Confirm') {
      snackbar('Successfully saved');
      void refresh();
    }
  };
